<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="name" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('name')">
                            <b-form-input v-model="formData.name" :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="surname" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('surname')">
                            <b-form-input v-model="formData.surname" :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="email" rules="required|email" v-slot="{ errors }">
                        <b-form-group :label="$t('email')">
                            <b-form-input v-model="formData.email" type="email" :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="mobile_tel" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('mobile_number')">
                            <b-form-input v-model="formData.mobile_tel" :state="errors[0] ? false : null"/>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="birthdate" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('birthdate')">
                            <select-date
                                :state="errors[0] ? false : (valid ? true : null)"
                                v-model="formData.birthdate"></select-date>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary" @click="createForm" :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>
<script>
import ChaperoneService from '@/services/ChaperoneService';
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            formData: {
                name: null,
                surname: null,
                email: null,
                mobile_tel: null,
                birthdate: null
            },
            formLoading: false
        }
    },
    methods: {
        async createForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid) {
                this.formLoading = true;
                ChaperoneService.store(this.formData)
                    .then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message));
                        this.$emit('createFormSuccess', true);
                    })
                    .catch(e => {
                        this.showErrors(e, this.$refs.formModalValidate);
                    })
                    .finally(() => {
                        this.formLoading = false;
                    });
            }
        }
    }
}
</script>
